import moment from 'moment'
const defaultFormat = 'MM/DD/YYYY'

//current time without timezone
export const now = () => moment().utc(false)
//get offSet(timezone)
export const offSet = moment().utcOffset()
//add timezone(offset)
export const formatDateWithTimezone = (data, format) => {
  if (data === null) {
    return ''
  }
  return moment(data)
    .utcOffset(offSet)
    .format(format || defaultFormat)
}
export const formatDateWithTimezoneWithUtc = (data, format) => {
  if (data === null) {
    return ''
  }
  return moment
    .utc(data)
    .utcOffset(120)
    .format(format || defaultFormat)
}
//we use this for datePicker
export const timeForDataPicker = (time, format) => {
  if (!time) {
    return ''
  }
  return moment(time).format(format || defaultFormat)
}
//show date without timezone, this is used when we want to show only date
export const timeWithoutTimeZone = (time, format) => {
  if (!time) {
    return ''
  }
  return moment.utc(time).format(format || defaultFormat)
}
//for date picker
export const dateFormatForDatePicker = (time, isTime) => {
  if (time) {
    const date = {
      year: +moment.utc(time).format('YYYY'),
      month: +moment.utc(time).format('MM'),
      day: +moment.utc(time).format('DD'),
      hours: +moment.utc(time).format('HH'),
      minutes: +moment.utc(time).format('mm'),
    }
    if (isTime) {
      const returnedDate = new Date(date.year, date.month - 1, date.day, date.hours, date.minutes, 0)
      return returnedDate || ''
    }
    return new Date(date.year, date.month - 1, date.day, 0, 0, 0)
  } else {
    return ''
  }
}
//database format date
export const dateFormatForDB = (time) => {
  return moment(time).format('YYYY-MM-DD')
}
//display date on table
export const displayDate = (date, format) => {
  if (!date) {
    return ''
  }
  return moment(date)
    .utc()
    .local()
    .format(format || defaultFormat)
}
